import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminTeamManagement = lazy(() => import("@/pages/admin/AdminTeamManagement"));

export const Route = createFileRoute("/admin/team")({
  component: AdminTeamManagement,
});
